import React from 'react';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import GenericError from '../components/shared/Errors/GenericError';

const LoadingError = () => {
    return (
        <Box
            sx={{
                backgroundColor: '#F4F5F6',
                inlineSize: 'unset',
                paddingTop: '80px',
                paddingBottom: '80px',
            }}
            className="b-container-content">
            <GenericError id="loading" title="Sorry, something went wrong">
                <Box>Please try to refresh your page or check back later.</Box>
            </GenericError>
        </Box>
    );
};

export default LoadingError;
